module.exports = __webpack_public_path__ + "img/top-header.70a7032d.svg";